module.exports = __webpack_public_path__ + "img/nav_icon_search.82969cd7.svg";